module.exports = __webpack_public_path__ + "static/media/scroll4_phone0.c75f8760.png";